import { ISelection } from '@checkout/items';
import { RootState } from '@checkout/state';
import * as cx from 'classnames';
import * as React from 'react';
import { Fragment } from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { nosto } from 'ys-analytics';
import messages from './../../../i18n/base-en';
import * as Styles from './Minicart.scss';

interface IOwnProps {
  showLabel?: boolean;
  cartLabel?: string;
}

interface IConnectedProps {
  selection?: ISelection;
  checkoutUrl: string;
}

interface IConnectetDispatchProps {}

type Props = IOwnProps & IConnectedProps & IConnectetDispatchProps & InjectedIntlProps;

class Minicart extends React.Component<Props, {}> {

  static defaultProps: IConnectedProps = {
    checkoutUrl: '',
  };

  handleNosto = (selection: ISelection | undefined): void => {
    const { nostoCart } = nosto;
    if (selection && selection.items && selection.items.length > 0) {
      try {
        nostoCart(selection);
      } catch (err) {
        // tslint:disable-next-line:no-console
        console.error('Enhanced Ecommerce error: ', err);
      }
    }
  }

  getItemQuantity = (selection: ISelection | undefined) =>
    selection &&
    selection.items &&
    selection.items.reduce((sum, product) => sum + product.quantity, 0)

  componentDidMount() {
    const { selection } = this.props;
    document.addEventListener('ysAnalytics/loadNostojs', () => {
      this.handleNosto(selection);
    });
  }

  componentDidUpdate() {
    const { selection } = this.props;
    this.handleNosto(selection);
  }

  render() {
    const { intl, selection, checkoutUrl, cartLabel, showLabel = true } = this.props;
    const { formatMessage } = intl;
    const quantity = this.getItemQuantity(selection) || 0;

    const minicartClassNames = cx({
      [Styles.minicart]: true,
      [`quantity--${quantity}`]: true,
    });

    const onlyQuantityClassNames = cx({
      [Styles.withLabel]: true,
      [`quantity--${quantity}`]: true,
    });

    const label = cartLabel ? cartLabel : formatMessage(messages.minicart_label);

    return (
      <Fragment>
        {showLabel && (
          <div className={minicartClassNames}>
            <a href={checkoutUrl}>
              <span className={Styles.label}>{label}</span>
              <span className={Styles.quantity}>{quantity}</span>
            </a>
          </div>
        )}
        {!showLabel && <span className={onlyQuantityClassNames}>{quantity}</span>}
      </Fragment>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  selection: state.checkout.selection,
  checkoutUrl: state.checkout.pathnames.checkout
});

export default compose<React.ComponentClass<IOwnProps>>(
  injectIntl,
  connect<IConnectedProps, IConnectetDispatchProps>(
    mapStateToProps,
    {},
  ),
)(Minicart);
